<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 25/9/2020
  -->

<template>
	<div v-if="menuItemsComputed.length > 0"
		 v-bind="attrsStylesClass"
		 class="row options-menu-root align-items-center mx-0 flex-nowrap"
		 :class="{'disabled': disabled}"
		 @click.stop>
<!--		<div v-if="actionItems.length > 0" class="">-->
			<span v-for="(menuItem, index) in actionItems" :key="index"
			:class="menuItem.class"
			:style="menuItem.style">


				<qw-link-button
					v-if="menuItem.showAsActionText"
					 @click="onClick(menuItem.action)">
					<span>{{menuItem.name}}</span>

				</qw-link-button>
				<ToolTipView
					v-else-if="menuItem.icon || menuItem.iconImage"
					position="top">

					<template #icon>
						<qw-button-icon
							:icon="menuItem.icon"
							:iconImage="menuItem.iconImage"
							:iconImageWidth="menuItem.iconImageWidth"
							@click="onClick(menuItem.action)"
						/>

<!--						<span class="button-circle" @click="onClick(menuItem.action)">-->
<!--							<img v-if="menuItem.iconImage" :src="require(`@/assets/images/${menuItem.iconImage}`)" :style="{'width': menuItem.iconImageWidth || '18px'}"/>-->
<!--							<i v-else class="fontello options-menu-font" :class="[menuItem.icon]" />-->
<!--						</span>-->

<!--						<img :src="require('@/' + menuItem.icon)" width="20px"/>-->
					</template>
					{{menuItem.name}}
				</ToolTipView>

				<div v-else @click="onClick(menuItem.action)"><small><qw-link-button>{{menuItem.name}}</qw-link-button></small></div>
			</span>
<!--		</div>-->
		<div>
			<el-popover
				v-if="menuItemsFinal.length"
				placement="bottom-end"
				:width="popupWidth"
				:visible="visible"
				v-model:visible="popupVisible"
				popper-class="options-menu-popover-root hide-on-print"
				@show="onPopoverVisibilityChanged"
				@hide="onPopoverVisibilityChanged"
				transition="null">
				<div @mouseenter="stopPopupCloseTimer" @mouseleave="startPopupCloseTimer">
					<ContextMenu
						class="options-menu-font"
						:menuItems="menuItemsFinal"
						@click="onClick"/>
				</div>
				<template #reference>
					<div @click="menuItemClicked" @mouseenter="() => forceHover = true" @mouseleave="() => {forceHover = false; startPopupCloseTimer()}">
						<slot>
							<qw-button-icon
								:disabled="disabled"
								:icon="menuIcon"/>
<!--							<span class="fontello button-circle cursor-pointer" :class="[menuIcon, {'hover': forceHover}]"/>-->
						</slot>
						<span v-if="showArrowDown" class="cursor-pointer fontello icon-angle-down bold"></span>
					</div>
				</template>

			</el-popover>
		</div>


	</div>
</template>

<script>
	import ContextMenu from "@/core/components/Menu/ContextMenu.vue";
	import {MenuAction} from "@/core/modules/coach/Resources/Files/QwoachDrive/MenuAction";
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
	import BaseComponent from "@/core/components/BaseComponent.vue";

	export default {
		name: "OptionsMenu",
		extends: BaseComponent,
		components: {ToolTipView, ContextMenu},
		props: {
			menuItems: {type: Array, default: () => []},
			menuIcon: {String, default: "icon-ellipsis-vert"},
			actionItemsMinWidth: String,
			showArrowDown: Boolean,
			popupWidth: {String, default: "13.125rem"},
			disabled: Boolean,
		},

		inheritAttrs: false,

		data(){
			return {
				popupVisible: false,
				forceHover: false,
				popupCloseTimer: null,
				popupCloseTimeout: 500,
				visible: false,
			}
		},

		methods: {

			stopPopupCloseTimer(){
				if(this.popupCloseTimer){
					clearTimeout(this.popupCloseTimer)
					this.popupCloseTimer = null
				}
			},
			startPopupCloseTimer(){
				this.popupCloseTimer = setTimeout(() => this.showPopup(false), this.popupCloseTimeout)
			},

			menuItemClicked(){
				if(!this.isDisabled){
					this.visible = !this.visible
					this.$emit("menuClicked")
				} else {
					this.visible = false
				}
			},

			showPopup(show){
				this.popupVisible = show
				this.visible = show
			},

			onPopoverVisibilityChanged(){
				console.log("onPopoverVisibilityChanged: ", this.popupVisible)
				this.$emit("onMenuVisibilityChanged", this.popupVisible)
			},

			onDeletePressed(){
				this.onClick(MenuAction.MOVE_TO_TRASH)
			},
			async onClick(action, options) {
				// if(!keepMenuPopup){
					this.showPopup(false)
				// }
				console.log("MenuItem click: ", action, ", options = ", options)
				await this.$nextTickPromise()
				this.$emit("click", action, options)
			},
		},
		computed: {
			hasDeleteAction(){
				for(let menuItem of this.menuItemsComputed){
					if(menuItem.action === MenuAction.MOVE_TO_TRASH){
						return true
					}
				}
				return false
			},
			actionsToExclude() {
				return [MenuAction.MOVE_TO_TRASH]
			},

			actionItems(){
				// console.trace("actionItems: ", this.menuItems)
				return this.menuItemsComputed.filter(menuItem => menuItem.showAsAction)
			},

			menuItemsFinal(){
				return this.menuItemsComputed.filter(menuItem => !menuItem.showAsAction)
			},

			menuItemsComputed(){
				return this.menuItems.filter(menuItem => !!menuItem)
			}
		}
	}
</script>

<style lang="scss">
	.options-menu-root {
		//.options-menu-font{
		//	font-size: 0.875rem;
		//}
	}

	.options-menu-popover-root {
		&.el-popover {
			padding: 0.5rem 0 !important;
		}
	}


</style>
